export default __webpack_public_path__ + "static/media/Abyssal Sting.0f8fca28.jpg";